import styled from '@emotion/styled';
import { FullTheme } from '../../themes';

export const Spacer = styled('div')<{
  height: number;
  bgColor?: (colors: FullTheme['custom']['colors']) => string;
}>((p) => ({
  minHeight: p.theme.spacing(p.height),
  width: '100%',
  background: p.bgColor?.(p.theme.custom.colors) || undefined
}));
